<template>
    <v-card max-width="700" min-width="500" v-if="activeCompany && activeCompany.ui_configurations">
        <v-card-title>{{ "UI configuration" | t }}</v-card-title>
        <v-divider class="mb-4 mt-4"/>

        <v-card-title>{{ "Modal" | t }}</v-card-title>
        <v-card-text>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Background:` }}
                </div>
                <v-menu v-model="menu.modal.background_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.background_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.background_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Header and footer background:` }}
                </div>
                <v-menu v-model="menu.modal.header_and_footer_background_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.header_and_footer_background_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.header_and_footer_background_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Body background (text part):` }}
                </div>
                <div style="min-width: 100px;">
                    <v-menu v-model="menu.modal.body_background_color" top nudge-bottom="105" nudge-left="16"
                            :close-on-content-click="false" :disabled="!editMode">
                        <template v-slot:activator="{ on }">
                            <div :style="swatchStyle(activeCompany.ui_configurations.modal.body_background_color)"
                                 :class="{'cursor-not-allowed': !editMode}"
                                 v-on="on"/>
                        </template>
                        <v-card>
                            <v-card-text class="pa-0">
                                <v-color-picker v-model="activeCompany.ui_configurations.modal.body_background_color" flat/>
                            </v-card-text>
                        </v-card>
                    </v-menu>
                </div>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Border color:` }}
                </div>
                <v-menu v-model="menu.modal.border_color" top nudge-bottom="105" nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.border_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.border_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>

            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Header text color:` }}
                </div>
                <v-menu v-model="menu.modal.header_text_color" top nudge-bottom="105" nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.header_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.header_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Body text color:` }}
                </div>
                <v-menu v-model="menu.modal.body_text_color" top nudge-bottom="105" nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.body_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.body_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Footer text color:` }}
                </div>
                <v-menu v-model="menu.modal.footer_text_color" top nudge-bottom="105" nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.footer_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.footer_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Select text color:` }}
                </div>
                <v-menu v-model="menu.modal.select_text_color" top nudge-bottom="105" nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.select_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.select_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
            <v-row no-gutters class="align-center mb-2">
                <div class="subtitle-1 pr-3">
                    {{ `Hovered bank border color:` }}
                </div>
                <v-menu v-model="menu.modal.hovered_bank_border_color" top nudge-bottom="105"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.hovered_bank_border_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.hovered_bank_border_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-row>
        </v-card-text>

        <v-card-actions v-if="activeUser.company_id && activeUser.company_role === 'owner' && !editMode">
            <v-spacer/>
            <v-btn color="black" text @click="handleEditClick">
                {{ "Edit" | t }}
            </v-btn>
        </v-card-actions>
        <v-card-actions v-if="activeUser.company_id && activeUser.company_role === 'owner' && editMode">
            <v-spacer/>
            <v-btn color="black" class="mr-2" text @click="handleResetClick">
                {{ "Reset" | t }}
            </v-btn>
            <v-btn color="black" text @click="handleSaveClick">
                {{ "Save" | t }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
    name: "ui-configuration-card",
    computed: {
        ...mapState([
            "activeUser",
            "activeCompany",
            "activeCompanyBanks",
            "activeCompanyAllowedIbans",
            "activeCompanyOrigins"
        ]),
        editMode () {
            return this.$route.name === 'ui-configuration-edit';
        }
    },
    data() {
        return {
            menu: {
                modal: {
                    header_and_footer_background_color: false,
                    body_background_color: false,
                    border_color: false,
                    text_color: false,
                    background_color: false,
                    header_text_color: false,
                    body_text_color: false,
                    footer_text_color: false,
                    select_text_color: false
                }
            },
        }
    },
    methods: {
        ...mapMutations(['resetActiveCompanyUiConfiguration', 'setRequestSuccess', 'setRequestError', 'setErrorMessage']),
        ...mapActions(['submitCompanyUpdate', 'getCompanyData']),
        handleEditClick() {
            this.$router.push({name: "ui-configuration-edit"});
        },
        async handleResetClick() {
            this.resetActiveCompanyUiConfiguration()
            await this.handleSaveClick()
        },
        async handleSaveClick() {

            const response = await this.submitCompanyUpdate({
                company: this.activeCompany,
                banks: this.activeCompanyBanks,
                origins: this.activeCompanyOrigins,
                allowed_ibans: this.activeCompanyAllowedIbans
            });
            if (response && response.status === 1) {
                await this.$router.push({
                    name: "settings-view"
                });
                if (this.activeUser.company_id) {
                    await this.getCompanyData(this.activeUser.company_id);
                }

                await this.setRequestSuccess(true);
            } else {
                await this.setRequestError(true);
                await this.setErrorMessage("Failed");
            }
        },
        swatchStyle(color) {
            return {
                backgroundColor: color,
                border: '1px solid #00000009',
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out'
            }
        }
    }
};
</script>

<style scoped>
.cursor-not-allowed {
    cursor: not-allowed !important;
}
</style>
